import React from 'react';
import { ProfileReferralsView } from '@/components/common/organisms';
import { useQuery } from '@tanstack/react-query';
import { investorReferralApi, investorReferralKeys } from '@/api/investor';
import { useTranslation } from 'react-i18next';
import { usePopups } from '@/hooks';

export const ProfileReferrals = () => {
  const { t } = useTranslation();
  const { showErrorToast } = usePopups();

  const refferalsPyramid = useQuery({
    queryKey: investorReferralKeys.getRefferalAccountsPyramid,
    queryFn: investorReferralApi.getMyRefferalAccountsPyramid,
    select: (data1) => data1.data,
    onError: () => showErrorToast('Structure fetch error')
  });

  const reccomenders = useQuery({
    queryKey: investorReferralKeys.getRecommendersAccounts,
    queryFn: investorReferralApi.getMyRecommenderAccounts,
    select: (data1) => data1.data,
    onError: () => showErrorToast('Assistant fetch error')
  });
  const agents = useQuery({
    queryKey: investorReferralKeys.getAgentAccounts,
    queryFn: investorReferralApi.getMyAgentAccounts,
    select: (data1) => data1.data,
    onError: () => showErrorToast('Agent fetch error')
  });

  return (
    <ProfileReferralsView
      refferalsPyramid={{
        list: refferalsPyramid.data,
        error: refferalsPyramid.isError,
        isLoading: refferalsPyramid.isLoading
      }}
      recommeders={{
        list: reccomenders.data,
        error: reccomenders.isError,
        isLoading: reccomenders.isLoading
      }}
      agents={{ list: agents.data, error: agents.isError, isLoading: agents.isLoading }}
    />
  );
};
